import React, { useState } from "react"
import { Autocomplete, IconButton, TextField } from "@mui/material"
import { Clear, Save } from "@mui/icons-material"
import { useMutation, gql } from "@apollo/client"

const UPDATE_FARM = gql`
  mutation UpdateFarm($pk: Int!, $name: String!) {
    update_farm_by_pk(pk_columns: { id: $pk }, _set: { name: $name }) {
      archived_at
      id
      name
    }
  }
`
const UPDATE_WAVE_BUOYS_AT_FARM = gql`
  mutation UpdateWaveBuoysAtFarm(
    $farmId: Int!
    $waveBuoys: [wave_buoy_to_farm_insert_input!]!
  ) {
    delete_wave_buoy_to_farm(where: { farm_id: { _eq: $farmId } }) {
      affected_rows
    }
    insert_wave_buoy_to_farm(objects: $waveBuoys) {
      affected_rows
    }
  }
`

export default function FarmEditForm({ farm, setEditing, waveBuoys }) {
  const [newName, setNewName] = useState(farm.name)
  const [updateFarm] = useMutation(UPDATE_FARM)
  const [updateWaveBuoysAtFarm] = useMutation(UPDATE_WAVE_BUOYS_AT_FARM)

  const currentWaveBuoyIds = farm.wave_buoy_to_farms.map(
    (buoy) => buoy.wave_buoy.id
  )
  const currentWaveBuoys = waveBuoys
    .filter((waveBuoy) => currentWaveBuoyIds.includes(waveBuoy.id))
    .map((waveBuoy) => waveBuoy.name)
  const [selectedWaveBuoys, setSelectedWaveBuoys] = useState([
    ...currentWaveBuoys,
  ])
  const selectedWaveBuoysIds = waveBuoys
    .filter((waveBuoy) => selectedWaveBuoys.includes(waveBuoy.name))
    .map((waveBuoy) => waveBuoy.id)

  const wave_buoys_to_farm = [
    ...selectedWaveBuoysIds.map((buoyId) => ({
      farm_id: farm.id,
      wave_buoy_id: buoyId,
    })),
  ]

  return (
    <div>
      <br />
      <TextField
        label="Name"
        value={newName}
        onChange={(e) => setNewName(e.target.value)}
      />

      <br />
      <Autocomplete
        disablePortal
        multiple
        id="combo-box-demo"
        options={waveBuoys.map((waveBuoy) => waveBuoy.name)}
        sx={{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Wave buoy" />}
        value={selectedWaveBuoys}
        onChange={(event, newInputValue) => setSelectedWaveBuoys(newInputValue)}
      />
      <br />
      <IconButton
        onClick={() => {
          updateFarm({
            variables: { pk: farm.id, name: newName },
          })
          updateWaveBuoysAtFarm({
            variables: { farmId: farm.id, waveBuoys: wave_buoys_to_farm },
          })

          setNewName("")
          setEditing(false)
        }}
      >
        <Save />
      </IconButton>
      <IconButton
        onClick={() => {
          setNewName("")
          setEditing(false)
        }}
      >
        <Clear />
      </IconButton>
    </div>
  )
}
